import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as fromLangActions from './actions';
import { AvailableLangs, LangDefault } from './reducer';
import { LangStorageService } from '../../services';

@Injectable()
export class LangEffects {
    public changeLang$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromLangActions.LangActionTypes.CHANGE_LANG),
            map((action: fromLangActions.ChangeLang) => action.payload),
            switchMap(payload => {
                if (payload !== LangDefault) {
                    if (!AvailableLangs.find(a => a === payload)) {
                        return of(new fromLangActions.ChangeLang(payload));
                    }
                }
                this.langStorageService.setValue(payload);
                this.translate.use(payload);
                return of();
            }),
        ),
    );

    constructor(
        public actions$: Actions,
        public langStorageService: LangStorageService,
        public translate: TranslateService,
    ) {}
}
